import React, { Component } from 'react';
import ConnectUI from './components/SignIn/Loginform';
import './components/Style/AppShell.css';

class App extends Component {
  render() {
    return <ConnectUI />;
  }
}

export default App;
